import { Api, createDbPaths } from '../paths';
import { DbRefs } from '../types';

export const createApi = (dbRefs: DbRefs): Api => {
	return createDbPaths(dbRefs);
};
